import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API_URL } from '../../Constants';
import { AuthContext } from '../context/AuthContext';

const WhatsAppReport = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedReport, setSelectedReport] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);

  const { user } = useContext(AuthContext);
    const token = user?.token || localStorage.getItem("token");
    const companyId =
      user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  // Fetch reports from API
  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/api/whatsapp/reports/today/${companyId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setReports(response.data);
        setLoading(false);
      } catch (err) {
        console.error('API Error:', err);
        setLoading(false);
      }
    };

    fetchReports();
  }, [companyId]);

  // View report details
  const viewReportDetails = async (report) => {
  setSelectedReport(report);
  setModalLoading(true);
  setShowModal(true);
  
  try {
    // For GET requests, we need to send parameters as query string
    const params = new URLSearchParams({
      companyId: companyId,
      templateName: report.templateName
    });
    
    const response = await axios.get(
      `${API_URL}/api/whatsapp/reports/getReports?${params}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    setModalData(response.data);
  } catch (err) {
    console.error('Modal API Error:', err);
  } finally {
    setModalLoading(false);
  }
};

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedReport(null);
    setModalData([]);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 ">
      <h1 className="text-xl font-bold text-gray-800 mb-2">WhatsApp Campaign Reports</h1>

      {/* Table */}
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Template Name
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Category
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Total Messages
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Total Debit
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Sent
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Delivered
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Seen
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Failed
                </th>
                <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {reports.length > 0 ? (
                reports.map((report, index) => (
                  <tr key={index} className="hover:bg-gray-50 cursor-pointer" onClick={() => viewReportDetails(report)}>
                    <td className="p-2 whitespace-nowrap text-xs font-medium text-gray-900">
                      {report.templateName || 'N/A'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.templateCategory || 'N/A'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.totalNumber || '0'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.totalDebit || '0.0'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.sentStatus || '0'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.deliveredStatus || '0'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.seenStatus || '0'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs text-gray-500">
                      {report.failedStatus || '0'}
                    </td>
                    <td className="p-2 whitespace-nowrap text-xs font-medium">
                      <button
                        onClick={() => viewReportDetails(report)}
                        className="text-green-600 hover:text-green-900"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="px-6 py-4 text-center text-sm text-gray-500">
                    No reports found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Report Detail Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
          <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-screen overflow-auto">
            <div className="flex items-center justify-between p-2 border-b">
              <h3 className="text-xl font-semibold text-gray-900">
                Message Details for {selectedReport?.templateName}
              </h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                onClick={closeModal}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            
            <div className="p-4">
              {modalLoading ? (
                <div className="flex justify-center items-center h-64">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Message ID
                        </th> */}
                        <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          To Number
                        </th>
                        <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          From Number
                        </th>
                        <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Debited Amount
                        </th>
                        <th className="p-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {modalData.length > 0 ? (
                        modalData.map((item, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {item.messageId ? `${item.messageId.substring(0, 15)}...` : 'N/A'}
                            </td> */}
                            <td className="p-1 whitespace-nowrap text-xs text-gray-500">
                              {item.toNumber || 'N/A'}
                            </td>
                            <td className="p-1 whitespace-nowrap text-xs text-gray-500">
                              {item.fromNumber || 'N/A'}
                            </td>
                            <td className="p-1 whitespace-nowrap">
                              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                                ${item.status === 'sent' ? 'bg-blue-100 text-blue-800' : 
                                  item.status === 'delivered' ? 'bg-yellow-100 text-yellow-800' : 
                                  item.status === 'read' ? 'bg-green-100 text-green-800' : 
                                  'bg-red-100 text-red-800'}`}>
                                {item.status || 'N/A'}
                              </span>
                            </td>
                            <td className="p-1 whitespace-nowrap text-xs text-gray-500">
                              {item.debitedAmount || '0.0'}
                            </td>
                            <td className="p-1 whitespace-nowrap text-xs text-gray-500">
                              {item.createdAt ? new Date(item.createdAt).toLocaleString() : 'N/A'}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">
                            No message details found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="flex items-center p-2 border-t border-gray-200 rounded-b">
              <button
                onClick={closeModal}
                type="button"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium p-2.5 hover:text-gray-900 focus:z-10"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppReport;